import { createSlice } from '@reduxjs/toolkit';
import State from '@/store/state';
import { cuid } from '@/utils';
const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: [],
    reducers: {
        /**
         * Low-level action for dispatching a fully-formed notification.
         * Prefer `addError` or `addSuccess` for typed convenience.
         */
        addNotification: {
            reducer: (state, action) => {
                state.push(action.payload);
            },
            prepare: (notification) => ({
                payload: Object.assign(Object.assign({}, notification), { visible: true }),
            }),
        },
        addError: {
            reducer: (state, action) => {
                state.push(action.payload);
            },
            prepare: (message, details, timeout) => ({
                payload: Object.assign(Object.assign({ id: cuid(), type: State.Notification.Type.ERROR, message, visible: true }, (details !== undefined ? { details } : {})), (timeout !== undefined ? { timeout } : {})),
            }),
        },
        addSuccess: {
            reducer: (state, action) => {
                state.push(action.payload);
            },
            prepare: (message, details, timeout) => ({
                payload: Object.assign(Object.assign({ id: cuid(), type: State.Notification.Type.SUCCESS, message, visible: true }, (details !== undefined ? { details } : {})), (timeout !== undefined ? { timeout } : {})),
            }),
        },
        closeNotification: (state, action) => {
            const item = state.find(({ id }) => id === action.payload);
            if (item) {
                item.visible = false;
            }
        },
        removeNotification: (state, action) => {
            const index = state.findIndex(({ id }) => id === action.payload);
            if (index !== -1) {
                state.splice(index, 1);
            }
        },
        clearNotifications: (state) => {
            state.splice(0);
        },
    },
});
export const { addNotification, addError, addSuccess, closeNotification, removeNotification, clearNotifications, } = notificationsSlice.actions;
export default notificationsSlice.reducer;
